import { type ChangeEvent } from "react";

import style from "./style.module.scss";
import themes from "../themes";
import { ArrowSelector, ColorPicker } from "../../../../ui";
import type { CalendarOptions, ProductSettingsProps } from "../../../types";

function ProductSettings({ options, setOptions }: ProductSettingsProps<CalendarOptions>) {
  const selectedTheme = themes.find((theme) => theme.value === options.theme) || themes[0];
  const color = options.color ? options.color : selectedTheme ? selectedTheme.color : null;

  const onChangeTheme = (theme: string) => {
    setOptions({ theme });
  };

  return (
    <div className={style.settings}>
      <div className={style.field}>
        <label className={style.label}>Année</label>
        <select
          value={options.year || 2026}
          onChange={(e: ChangeEvent<HTMLSelectElement>) =>
            setOptions({ year: parseInt(e.target.value) })
          }
          className={style.select}
        >
          {[2024, 2025, 2026, 2027, 2028, 2029, 2030].map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      <div className={style.field}>
        <label className={style.label}>Thème</label>
        <ArrowSelector
          options={themes}
          value={options.theme || themes[0].value}
          onChange={onChangeTheme}
        />
      </div>

      <div className={style.field}>
        <label className={style.label}>Couleur</label>
        <ColorPicker value={color} onChange={(color) => setOptions({ color })} />
      </div>
    </div>
  );
}

export default ProductSettings;
